import * as React from 'react';

export const ViewAllSvg: React.FC = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={71} height={24} fill='none'>
      <path
        fill='#193364'
        d='M4.241 18 .801 9.968H2.21l2.88 7.072h-.432L7.57 9.968h1.344L5.473 18H4.241Zm6.132 0V9.968h1.296V18h-1.296Zm-.16-9.856V6.688h1.6v1.456h-1.6Zm7.54 10c-1.258 0-2.25-.363-2.975-1.088-.726-.736-1.088-1.755-1.088-3.056 0-.843.16-1.573.48-2.192.32-.63.768-1.115 1.344-1.456.576-.352 1.237-.528 1.984-.528.736 0 1.354.155 1.856.464.501.31.885.752 1.152 1.328.267.565.4 1.237.4 2.016v.48h-6.224v-.816h5.376l-.272.208c0-.853-.192-1.52-.576-2-.384-.48-.955-.72-1.712-.72-.8 0-1.424.283-1.872.848-.448.555-.672 1.307-.672 2.256v.144c0 1.003.245 1.765.736 2.288.501.512 1.2.768 2.096.768.48 0 .928-.07 1.344-.208.427-.15.832-.39 1.216-.72l.448.912c-.352.341-.8.608-1.344.8a5.234 5.234 0 0 1-1.696.272ZM24.94 18l-2.976-8.032h1.376l2.48 7.072h-.416l2.56-7.072h1.12l2.512 7.072h-.4l2.496-7.072h1.312L32.011 18h-1.248l-2.592-7.184h.64L26.203 18H24.94Zm23.162.144c-.714 0-1.338-.165-1.872-.496-.533-.341-.95-.821-1.248-1.44-.288-.619-.432-1.36-.432-2.224 0-.875.144-1.621.432-2.24.299-.619.715-1.093 1.248-1.424.534-.33 1.158-.496 1.872-.496.726 0 1.35.187 1.872.56a2.55 2.55 0 0 1 1.056 1.488h-.192l.176-1.904h1.248l-.096.944c-.021.31-.032.613-.032.912V18h-1.296v-1.888h.176a2.55 2.55 0 0 1-1.056 1.488c-.533.363-1.152.544-1.856.544Zm.256-1.056c.768 0 1.376-.261 1.824-.784.448-.533.672-1.307.672-2.32 0-1.024-.224-1.797-.672-2.32-.448-.533-1.056-.8-1.824-.8-.757 0-1.365.267-1.824.8-.448.523-.672 1.296-.672 2.32 0 1.013.224 1.787.672 2.32.459.523 1.067.784 1.824.784ZM54.64 18V6.224h1.296V18h-1.296Zm3.813 0V6.224h1.296V18h-1.296Z'
      />
      <g clipPath='url(#a)'>
        <path
          stroke='#193364'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.5}
          d='m66 17 4-4-4-4'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M65 8h6v10h-6z' />
        </clipPath>
      </defs>
    </svg>
  );
};
